window.uetq = window.uetq || [];

const microsoftAdsBingConversion = ({ total: { grand_total: { value, currency } } }) => {
    window.uetq.push({ gv: value, gc: currency });
};

export {
    microsoftAdsBingConversion,
};
